export const SET_WALLET = "SET_WALLET"
export const UPDATE_WALLET_NAME = "UPDATE_WALLET_NAME"
export const UPDATE_WALLET = "UPDATE_WALLET_NAME"
export const UPDATE_WALLET_PASSWORD = "UPDATE_WALLET_PASSWORD"
export const SET_BALANCE = "SET_BALANCE"
export const UPDATE_BALANCE = "UPDATE_BALANCE"
export const DELETE_BALANCE = "DELETE_BALANCE"
